import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { Angulartics2Module } from 'angulartics2';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FullCalendarModule } from '@fullcalendar/angular';

import { WhatsappToggleModule } from '@tablesready/frontend-whatsapp-toggle';
import { FrontendCountdownTimerModule } from '@tablesready/frontend-countdown-timer';
import {
  CommonRadioGroupModule,
  CommonUiModule,
  FormValidationModule,
  PipesModule,
  SharedTabsModule,
  TabsModule,
  TimepickerModule,
  UtilsModule,
} from '@tablesready/common-ui';
import { CanvasModule } from '@tablesready/canvas';
import { ReservationsRoutingModule } from './reservations.routing.module';
import { COMPONENTS } from './components';
import { ReservationsComponent } from './reservations.component';
import { PartyCustomFieldsModule } from '@tablesready/frontend-party-custom-fields';
import { IonicModule } from '@ionic/angular';
import { FrontendHeaderModule } from '@tablesready/frontend-header';
import { AlertsModule, ClockModule } from '@tablesready/frontend-alerts-bar';
import { StatusModule } from '@tablesready/frontend-status-bar';
import { FrontendDropdownModule } from '@tablesready/frontend-dropdown';
import { FrontendPullRefreshModule } from '@tablesready/frontend-pull-refresh';
import { FrontendModalModule } from '@tablesready/frontend-modal';
import { BadgeModule } from '@tablesready/frontend-badge';
import { SizeModule } from '../components/size/size.module';
import { DurationModule } from '../components/duration/duration.module';

@NgModule({
  declarations: [ReservationsComponent, ...COMPONENTS],
  imports: [
    PipesModule,
    CommonRadioGroupModule,
    CommonModule,
    Angulartics2Module,
    ReservationsRoutingModule,
    StatusModule,
    ClockModule,
    AlertsModule,
    NgbModule,
    FormsModule,
    UtilsModule,
    TimepickerModule,
    FormValidationModule,
    NgSelectModule,
    InfiniteScrollModule,
    CommonUiModule,
    FullCalendarModule,
    WhatsappToggleModule,
    CanvasModule,
    TabsModule,
    SharedTabsModule,
    PartyCustomFieldsModule,
    IonicModule,
    FrontendHeaderModule,
    FrontendDropdownModule,
    FrontendPullRefreshModule,
    FrontendModalModule,
    BadgeModule,
    FrontendCountdownTimerModule,
    ReactiveFormsModule,
    SizeModule,
    DurationModule,
  ],
})
export class ReservationsModule { }
